"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceService = void 0;
const optimistic_minting_1 = require("./optimistic-minting");
const spv_1 = require("./spv");
/**
 * Service exposing features relevant to authorized maintainers and
 * operators of the tBTC v2 system.
 */
class MaintenanceService {
    constructor(tbtcContracts, bitcoinClient) {
        this.optimisticMinting = new optimistic_minting_1.OptimisticMinting(tbtcContracts);
        this.spv = new spv_1.Spv(tbtcContracts, bitcoinClient);
    }
}
exports.MaintenanceService = MaintenanceService;
//# sourceMappingURL=maintenance-service.js.map